"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCertTypeIcon = exports.innKppString = exports.highlight = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Cloud_1 = tslib_1.__importDefault(require("@skbkontur/react-icons/Cloud"));

var common_1 = require("../../utils/common");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

exports.highlight = function (fieldName, fieldValue, item, hlClass) {
  if (!item.searchMatchedInfo) {
    return fieldValue;
  }

  var matched = item.searchMatchedInfo.matched;

  if (!matched[fieldName]) {
    return fieldValue;
  }

  var template = matched[fieldName].sort().reverse().map(function (m) {
    return common_1.escapeRegExp(m);
  }).join('|');
  var re = new RegExp("" + template, 'ig');
  return fieldValue.replace(re, "<span class=" + hlClass + ">$&</span>");
};

exports.innKppString = function (inn, kpp, usePrefix) {
  if (usePrefix === void 0) {
    usePrefix = false;
  }

  var innKpp = [];
  var innTemplate = usePrefix ? "\u0418\u041D\u041D " + inn : "" + inn;
  var kppTemplate = usePrefix ? "\u041A\u041F\u041F " + kpp : "" + kpp;

  if (inn) {
    innKpp.push(innTemplate);
  }

  if (kpp) {
    innKpp.push(kppTemplate);
  }

  var separator = usePrefix ? '  ' : ' – ';
  return innKpp.join(separator);
};

exports.getCertTypeIcon = function (certificate) {
  return [Plugin_1.CertificateType.Cloud, Plugin_1.CertificateType.DSS].includes(certificate.type()) ? react_1.default.createElement("span", null, "\xA0", react_1.default.createElement(Cloud_1.default, null)) : '';
};